import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DistribucionAnexo21y22RMF2026DatosGenerales() {
  return (
    <CategoryPage
      category="distribucionAnexo21Y22Rmf2026DatosGenerales2026"
      pageTitle="Datos Generales 2026"
    />
  );
}

export default DistribucionAnexo21y22RMF2026DatosGenerales;
